import type { ImageComment } from '@reflex/ui/components/content/ImageCommentContext';

/**
 * Turn a pin dropped on an image into the message the agent receives.
 *
 * The agent cannot see where the cursor was, so the location has to survive as
 * words. Percentages always go out because they hold no matter how the browser
 * scaled the image; the intrinsic pixel coordinates go out too when the browser
 * decoded them, which is what an agent needs to crop the region and look at it.
 */
export function formatImageCommentMessage(comment: ImageComment): string {
  const across = Math.round(comment.fraction.x * 100);
  const down = Math.round(comment.fraction.y * 100);
  const label = comment.target.alt.trim() || 'image';
  const { pixels } = comment;
  const where = pixels
    ? `${across}% across and ${down}% down (around pixel ${pixels.x}, ${pixels.y} of ${pixels.width} x ${pixels.height})`
    : `${across}% across and ${down}% down`;
  return `Feedback on the image "${label}", at the point ${where} from the top left:\n\n${comment.text.trim()}`;
}
